import styled, { css } from "styled-components";
const StyledLabel = styled.h5(
  ({ theme }) => css`
    font-weight: bold;
    margin-bottom: ${theme.spacings.sm};
  `
);
export default StyledLabel;
